module.exports = __webpack_public_path__ + "img/34-s.c2937d31.png";